export default {
  getUserIndexInfoList: {
    url: "/mock/dashboard/operation-index/user-index/info/list",
    method: "get",
    desc: "分页查询用户运行指标-用户信息",
    topTips: true
  },
  getUserIndexOverview: {
    url: "/mock/dashboard/operation-index/user-index/overview",
    method: "get",
    desc: "分页查询用户运行指标-概览",
    topTips: true
  }
};
